import type { IamOkMessageMembersType } from '../../routes/ImOk';
import type { ImOkDocumentSimple } from './imOkSlice/types';

type GetIamOkInitiallSelectedParams = {
  meesageType: IamOkMessageMembersType;

  iamOk: ImOkDocumentSimple;

  withoutCurrentUserId?: number;
};
export const getIamOkInitiallSelected = (params: GetIamOkInitiallSelectedParams): Set<number> => {
  const { iamOk, meesageType, withoutCurrentUserId } = params;
  switch (meesageType) {
    case 'ALL':
      return new Set(
        iamOk.users
          .map(member => member.userid)
          .filter(id => {
            if (withoutCurrentUserId) return id !== withoutCurrentUserId;
            return true;
          })
      );
    case 'NOT_OK':
      return new Set(
        iamOk.users
          .filter(user => user.imok === false)
          .map(user => user.userid)
          .filter(id => {
            if (withoutCurrentUserId) return id !== withoutCurrentUserId;
            return true;
          })
      );
    case 'NO_STATUS':
      return new Set(
        iamOk.users
          .filter(user => user.imok === null)
          .map(user => user.userid)
          .filter(id => {
            if (withoutCurrentUserId) return id !== withoutCurrentUserId;
            return true;
          })
      );
    case 'OK':
      return new Set(
        iamOk.users
          .filter(user => user.imok)
          .map(user => user.userid)
          .filter(id => {
            if (withoutCurrentUserId) return id !== withoutCurrentUserId;
            return true;
          })
      );
    default:
      return new Set(
        iamOk.users
          .map(member => member.userid)
          .filter(id => {
            if (withoutCurrentUserId) return id !== withoutCurrentUserId;
            return true;
          })
      );
  }
};

export const checkIfNotZeroMembers = (
  type: IamOkMessageMembersType,
  iamOk: ImOkDocumentSimple
): boolean => {
  switch (type) {
    case 'ALL':
      return new Set(iamOk.users.map(member => member.userid)).size === 0;
    case 'NOT_OK':
      return (
        new Set(iamOk.users.filter(user => user.imok === false).map(user => user.userid)).size === 0
      );
    case 'NO_STATUS':
      return (
        new Set(iamOk.users.filter(user => user.imok === null).map(user => user.userid)).size === 0
      );
    case 'OK':
      return new Set(iamOk.users.filter(user => user.imok).map(user => user.userid)).size === 0;
    default:
      return new Set(iamOk.users.map(member => member.userid)).size === 0;
  }
};
